import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import  'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw'

@Injectable({
  providedIn: 'root'
})

export class AuthService {

  loginUrl: string; 
  public passwordChangable = true;

  constructor(private http: HttpClient ) {}

  get windowRef() {
    return window;
  }

  getUserData() {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization':  'Bearer ' + sessionStorage.getItem('token')});
    const options = {headers: headers};
    return this.http.get(environment.baseURL + 'users/profile', options).catch(this.errorHandler);
  }
  
  loggedIn(logindata): Observable<any> {
    return this.http.post(environment.baseURL + 'login', logindata).catch(this.errorHandler);
  }
  
  registerdata(data): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'users', data, options)
    .catch(this.errorHandler);
  }
  registerTempdata(data):any {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'temp-users', data, options)
    .catch(this.errorHandler);
  }
  checkUserExist(data):any{
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'users/checkUserExist', data, options)
    .catch(this.errorHandler);
  }
  CreatEmailotp(email) {
    return this.http.post(environment.baseURL + 'auth/refresh/generate', email)
    .catch(this.errorHandler);
  }
  sendEmailOtp(email){
    return this.http.post(environment.baseURL + 'auth/refresh/generateOtp', email)
    .catch(this.errorHandler);
  }
  CreateVerifyEmail(emailData) {
    return this.http.post(environment.baseURL + 'auth/refresh/otp/email', emailData)
    .catch(this.errorHandler);
  }
 
  GenarteEmailOtp(email) {
    return this.http.post(environment.baseURL + 'auth/refresh/forgotPassword/generate', email)
    .catch(this.errorHandler);
  }

  verifyEmail(emailData) {
    return this.http.post(environment.baseURL + 'auth/refresh/forgotPasswordOtp/email', emailData)
    .catch(this.errorHandler);
  }

  Forgetpassword(passwordData): Observable<any> {
    return this.http.post(environment.baseURL + 'auth/refresh/forgotPassword', passwordData);
  }

  Updatepassword(userpassword: any): Observable<any> {
    const headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization':  'Bearer ' + sessionStorage.getItem('token')});
    const options = {headers: headers};
    return this.http.post(environment.baseURL + 'users/changePassword', userpassword, options);
  }

  getTermsConitionslinks() {
    return this.http.get(environment.baseURL + 'users/contentTerms&Condition').catch(this.errorHandler);
  }

  logout(): void {
  sessionStorage.removeItem('isLoggedIn')
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('ChangedPasswordDone');
  sessionStorage.removeItem('setupTime');
  sessionStorage.removeItem('value');
 // sessionStorage.clear();
  }

  errorHandler(error: HttpErrorResponse) {
    return Observable.throw(error || "Server Error");
  }

}
